// Tenant-facing product update feed shown in Help Center → What's new.
// Newest first. tag: "New" | "Improvement" | "Fix".
export const PRODUCT_UPDATES = [
  {
    date: "June 2026",
    tag: "New",
    title: "Open early, close early — one-tap operating mode",
    body: "Your order Board now has a simple three-way switch for each spot: Auto (follow your saved hours), Open now (take orders even when your hours say you're closed \u2014 opened early or staying late), and Closed (stop online orders for today even during your hours \u2014 sold out or closing early). Open now and Closed only last for today and reset to Auto overnight, so you never forget to switch back. Everything customers see \u2014 your storefront, cart and checkout \u2014 stays in perfect sync, and a new \u201CCurrently: \u2026\u201D chip at the top of your dashboard shows your live status at a glance. Got more than one location? Each shop, truck or pop-up has its own switch. See Help \u2192 Taking orders and Locations.",
  },
  {
    date: "July 27, 2026",
    tag: "Fix",
    title: "Smoother event booking: sign-in links & add-ons",
    body: "Two booking-widget fixes. (1) If a customer emails themselves a sign-in link mid-booking, the link now brings them right back into your booking flow \u2014 signed in and exactly where they left off \u2014 instead of dropping them on their account page. (2) Add-ons now always appear right after the \u201CBuild your menu\u201D step, even when a customer taps \u201CBook now\u201D straight from a package (previously they could be skipped).",
  },
  {
    date: "July 27, 2026",
    tag: "Improvement",
    title: "Customer email replies always reach you",
    body: "Order & event emails now say \u201Creply to this email\u201D only when your business email is set, so replies land in your inbox. If it isn\u2019t set yet, emails tell customers to call or text your business phone instead \u2014 a reply never disappears into a dead inbox. Set yours in Settings \u2192 Business info.",
  },
  {
    date: "July 26, 2026",
    tag: "New",
    title: "Mix & match event packages",
    body: "Build packages where guests pick a total number of items across categories — with a minimum from each. Example: \u201C3 drinks across Matcha + Refresher, at least 1 of each\u201D now correctly allows 2+1 or 1+2 (never 3+0). The package editor shows a live preview of every allowed combination, and we fixed a counter that could get stuck at checkout.",
  },
  {
    date: "July 26, 2026",
    tag: "Improvement",
    title: "\u201CReady by\u201D time + pickup address in order emails",
    body: "Order confirmation emails now lead with a bold pickup block: a real \u201CReady by [time]\u201D estimate driven by your live order-board wait time, plus the exact pickup location address (multi-location & pop-up aware) and a one-tap \u201CGet directions\u201D link \u2014 so customers know exactly when and where to head over.",
  },
  {
    date: "July 26, 2026",
    tag: "New",
    title: "Set your store\u2019s time zone",
    body: "Head to Settings \u2192 Business hours and choose your local time zone. Your \u201CReady by\u201D times, dashboard stats, Reporting and the Z-report now all display in your local time instead of UTC.",
  },
  {
    date: "July 26, 2026",
    tag: "Fix",
    title: "Register respects sales channels",
    body: "Items marked for Events only (Online / Register unchecked) no longer appear on your POS Register, keeping event-only service items out of walk-up sales.",
  },
];
